import React, { Component } from 'react'
import T from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Paper from '@material-ui/core/Paper'

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    padding: theme.spacing(0.5),
    marginBottom: 5,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
})

class FilterBlock extends Component {
  constructor(props) {
    super(props)
    this.psfs = props.psfs
    this.state = {
      activeFilters: this.psfs.filtersObj.getFilters(),
    }
  }

  setActiveFiltersState() {
    this.setState({
      activeFilters: this.psfs.filtersObj.getFilters(),
    })
    this.setFilterCriteria()
  }

  setFilterCriteria() {
    const { history } = this.context.router
    this.psfs.paginationObj.setPage(1)
    history.push(this.psfs.path)
  }

  onFilterChange = e => {
    const { name, value } = e.target
    const filters = this.mappingFilters(this.props.filters)
    const { type } = filters[name]
    const { filtersObj } = this.psfs
    value === 'all'
      ? filtersObj.clearFilter(name)
      : filtersObj.setFilter(name, value, type)
    this.setActiveFiltersState()
  }

  onFilterClear = key => () => {
    const { filtersObj } = this.psfs
    filtersObj.clearFilter(key)
    this.setActiveFiltersState()
  }

  onFilterClearAll = () => {
    this.psfs.filtersObj.clearAll()
    this.setActiveFiltersState()
  }

  mappingFilters = filters => {
    const _filters = {}

    // eslint-disable-next-line guard-for-in
    for (const x in filters) {
      const filter = filters[x]
      const { id, value } = filter.map
      const _filter = {
        label: filter.label,
        type: filter.type,
        list: {},
      }

      // eslint-disable-next-line guard-for-in
      for (const y in filter.data) {
        const row = filter.data[y]
        _filter.list[row[id]] = row[value]
      }

      _filters[filter.entity] = _filter
    }

    return _filters
  }

  render() {
    const { classes, isOpen, onClose } = this.props
    const filters = this.mappingFilters(this.props.filters)

    if (Object.keys(filters).length < 1) {
      return null
    }

    const { activeFilters } = this.state
    const issetActiveFilters = Object.keys(activeFilters).length > 0

    return (
      <>
        {issetActiveFilters && (
          <Paper className={classes.root}>
            {Object.keys(activeFilters).map((key, index) => {
              const filter = activeFilters[key]

              return (
                <Chip
                  key={`active_filter_${index}`}
                  label={filters[key].list[filter.values[0]]}
                  className={classes.chip}
                  onDelete={this.onFilterClear(key)}
                />
              )
            })}
          </Paper>
        )}

        <Dialog
          open={isOpen}
          onClose={onClose}
          aria-labelledby="form-dialog-title"
          paperWidthMd>
          <DialogTitle id="form-dialog-title">Filters</DialogTitle>
          <DialogContent>
            {Object.keys(filters).map((key, index) => {
              const filter = filters[key]
              let listValue = 'all'

              if (issetActiveFilters && activeFilters.hasOwnProperty(key)) {
                listValue = activeFilters[key].values[0]
              }

              return (
                <FormControl
                  fullWidth
                  className={`${classes.formControl} filter-table-item`}
                  key={index}>
                  <InputLabel htmlFor="age-native-simple">
                    {filter.label}
                  </InputLabel>
                  <Select
                    key={`filter_${key}select`}
                    value={listValue}
                    onChange={this.onFilterChange}
                    data-type={filter.type}
                    inputProps={{
                      id: `filter_${key}`,
                      name: key,
                    }}
                    MenuProps={{ getContentAnchorEl: null }}>
                    <MenuItem value="all" key={`fon_${key}`}>
                      All
                    </MenuItem>
                    {Object.keys(filter.list).map(id => {
                      const value = filter.list[id]

                      return (
                        <MenuItem value={id} key={`f_${id}_${key}`}>
                          {value}
                        </MenuItem>
                      )
                    })}
                  </Select>
                </FormControl>
              )
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onFilterClearAll} color="default">
              Clear All
            </Button>
            <Button onClick={onClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

FilterBlock.propTypes = {
  classes: T.object.isRequired,
}

FilterBlock.contextTypes = {
  router: T.shape({
    history: T.object.isRequired,
  }).isRequired,
}

export default withStyles(styles)(FilterBlock)
